import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=64d4c879&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=64d4c879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4c879",
  null
  
)

export default component.exports